import _implicitStylesheets from "./header.css";
import _implicitScopedStylesheets from "./header.scoped.css?scoped=true";
import _aceTbid from "ace/tbid";
import _aceNotifications from "ace/notifications";
import _wdsLink from "wds/link";
import _aceHelpCenter from "ace/helpCenter";
import _aceFavorites from "ace/favorites";
import _wdsButton from "wds/button";
import _aceUserMenu from "ace/userMenu";
import _axCard from "ax/card";
import _wdsPopover from "wds/popover";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import _aceAppLauncher from "ace/appLauncher";
import _searchTypeAhead from "search/typeAhead";
import {freezeTemplate, parseFragment, registerTemplate, sanitizeAttribute} from "lwc";
const $fragment1 = parseFragment`<a${"a0:href"}${"a0:aria-label"} class="header-logo appx${0}"${2}><img src="/images/salesforce-logo-2x.png" alt=""${3}><span${3}>${"t3"}</span></a>`;
const $fragment2 = parseFragment`<div class="vertical-divider${0}"${2}></div>`;
const $fragment3 = parseFragment`<a${"a0:href"}${"a0:aria-label"} class="header-logo agentx${0}"${2}><span${"c1"}${2}>${"t2"}</span></a>`;
const $fragment4 = parseFragment`<div class="header-center${0}"${2}></div>`;
const $fragment5 = parseFragment`<a${"a0:href"} class="nav_actionable-item${0}"${2}><span class="slds-truncate${0}"${2}>${"t2"}</span></a>`;
const $fragment6 = parseFragment`<a href="javascript:void(0);" class="nav_actionable-item${0}"${"a0:aria-expanded"}${2}><span class="slds-truncate${0}"${2}>${"t2"}</span></a>`;
const $fragment7 = parseFragment`<svg class="bucket-icon${0}" role="img"${2}><use${"a1:xlink:href"}${3}/><title${3}>${"t3"}</title></svg>`;
const $fragment8 = parseFragment`<a class="navigation-link${0}"${"a0:href"}${2}>${"t1"}</a>`;
const $fragment9 = parseFragment`<div class="bucket-description${0}"${2}>${"t1"}</div>`;
const $fragment10 = parseFragment`<svg class="bucket-icon${0}" role="img"${2}><use${"a1:xlink:href"}${3}/><title${3}>${"t3"}</title></svg>`;
const $fragment11 = parseFragment`<a class="navigation-link nav_actionable-item${0}"${"a0:href"}${2}>${"t1"}</a>`;
const $fragment12 = parseFragment`<a${"a0:href"} class="nav_actionable-item${0}"${2}><span class="slds-truncate${0}"${2}>${"t2"}</span></a>`;
const $fragment13 = parseFragment`<a${"a0:href"} class="nav_actionable-item${0}"${2}><span class="slds-truncate${0}"${2}>${"t2"}</span></a>`;
const $fragment14 = parseFragment`<a${"a0:href"} class="nav_actionable-item${0}"${2}><span class="slds-truncate${0}"${2}>${"t2"}</span></a>`;
const $fragment15 = parseFragment`<div class="header-center${0}"${2}></div>`;
const stc0 = {
  key: 0
};
const stc1 = {
  key: 1
};
const stc2 = {
  classMap: {
    "header-wrapper": true
  },
  key: 3
};
const stc3 = {
  key: 4
};
const stc4 = {
  classMap: {
    "header-wrapper_top": true
  },
  key: 5
};
const stc5 = {
  classMap: {
    "home-link-container": true
  },
  key: 6
};
const stc6 = {
  classMap: {
    "agentexchange-link-container": true
  },
  key: 10
};
const stc7 = {
  classMap: {
    "header-nav-utilities_mobile": true
  },
  key: 16
};
const stc8 = {
  classMap: {
    "utility-items": true
  },
  key: 17
};
const stc9 = {
  classMap: {
    "utility-item": true
  },
  key: 18
};
const stc10 = {
  classMap: {
    "utility-item": true
  },
  key: 20
};
const stc11 = {
  key: 21
};
const stc12 = {
  classMap: {
    "header-wrapper_top": true,
    "mobile-menu": true
  },
  key: 22
};
const stc13 = {
  "header-button": true
};
const stc14 = {
  "data-id": "appx_phone_nav_trigger"
};
const stc15 = {
  "close-button": true,
  "header-button": true
};
const stc16 = {
  classMap: {
    "header-nav-utilities_mobile": true
  },
  key: 27
};
const stc17 = {
  classMap: {
    "utility-items": true
  },
  key: 28
};
const stc18 = {
  classMap: {
    "utility-item": true,
    "authentication": true
  },
  key: 29
};
const stc19 = {
  "data-testid": "signup"
};
const stc20 = {
  classMap: {
    "utility-item": true,
    "authentication": true
  },
  key: 31
};
const stc21 = {
  "data-testid": "login"
};
const stc22 = {
  classMap: {
    "utility-item": true
  },
  key: 33
};
const stc23 = {
  attrs: {
    "data-testid": "mobile"
  },
  key: 34
};
const stc24 = {
  "header-nav-items": true
};
const stc25 = {
  "type": "headerNavLink"
};
const stc26 = {
  classMap: {
    "nav-items-list": true
  },
  key: 37
};
const stc27 = {
  classMap: {
    "nav-item-li": true
  },
  key: 38
};
const stc28 = {
  classMap: {
    "nav-item-li": true,
    "explore-item": true
  },
  key: 42
};
const stc29 = {
  classMap: {
    "explore-popover-content": true
  },
  key: 47
};
const stc30 = {
  "role": "group",
  "padding": "medium",
  "shadow": "default"
};
const stc31 = {
  classMap: {
    "bucket-title": true
  },
  key: 51
};
const stc32 = {
  classMap: {
    "explore-mobile-options": true
  },
  key: 57
};
const stc33 = {
  "explore-mobile-option": true
};
const stc34 = {
  key: 59
};
const stc35 = {
  classMap: {
    "bucket-title": true
  },
  key: 62
};
const stc36 = {
  key: 63
};
const stc37 = {
  classMap: {
    "nav-item-li": true
  },
  key: 66
};
const stc38 = {
  classMap: {
    "nav-item-li": true
  },
  key: 70
};
const stc39 = {
  classMap: {
    "nav-item-li": true
  },
  key: 74
};
const stc40 = {
  classMap: {
    "header-nav-utilities": true
  },
  attrs: {
    "role": "navigation"
  },
  key: 80
};
const stc41 = {
  classMap: {
    "utility-items": true
  },
  key: 81
};
const stc42 = {
  classMap: {
    "utility-item": true,
    "nav_group-0": true
  },
  key: 82
};
const stc43 = {
  classMap: {
    "utility-item": true,
    "nav_group-0": true
  },
  key: 84
};
const stc44 = {
  classMap: {
    "app-launcher": true
  },
  key: 85
};
const stc45 = {
  classMap: {
    "utility-item": true,
    "nav_group-0": true
  },
  key: 86
};
const stc46 = {
  key: 87
};
const stc47 = {
  classMap: {
    "utility-item": true,
    "nav_group-0": true
  },
  key: 88
};
const stc48 = {
  key: 89
};
const stc49 = {
  classMap: {
    "utility-item": true,
    "nav_group-1": true
  },
  key: 90
};
const stc50 = {
  classMap: {
    "utility-item": true,
    "nav_group-1": true
  },
  key: 92
};
const stc51 = {
  classMap: {
    "header--search": true
  },
  key: 94
};
const stc52 = {
  key: 95
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {c: api_custom_element, ncls: api_normalize_class_name, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment, h: api_element, b: api_bind, k: api_key, fid: api_scoped_frag_id, i: api_iterator} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5, _m6, _m7, _m8, _m9, _m10, _m11, _m12} = $ctx;
  return [api_custom_element("ace-tbid", _aceTbid, stc0), api_element("header", stc1, [api_element("div", {
    className: api_normalize_class_name($cmp.outerClass),
    key: 2
  }, [api_element("div", stc2, [api_custom_element("ace-notifications", _aceNotifications, stc3), api_element("div", stc4, [api_element("div", stc5, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "label": $cmp.labels.linkHomeLogoLabel
    },
    key: 7
  }, [api_static_fragment($fragment1, 9, [api_static_part(0, {
    attrs: {
      "href": $cmp.links.home,
      "aria-label": $cmp.labels.linkHomeLogoLabel
    }
  }, null), api_static_part(3, null, api_dynamic_text($cmp.labels.appexchangeName))])]), api_element("div", stc6, [api_static_fragment($fragment2, 12), api_custom_element("wds-link", _wdsLink, {
    props: {
      "label": $cmp.labels.linkAgentExchangeLabel
    },
    key: 13
  }, [api_static_fragment($fragment3, 15, [api_static_part(0, {
    attrs: {
      "href": $cmp.links.agentExchange,
      "aria-label": $cmp.labels.linkAgentExchangeLabel
    }
  }, null), api_static_part(1, {
    className: api_normalize_class_name($cmp.agentExchangeCopyClasses)
  }, null), api_static_part(2, null, api_dynamic_text($cmp.labels.agentexchangeName))])])])]), !$cmp.showBasicHeader ? api_element("div", stc7, [api_element("ul", stc8, [$cmp.isAppExchange ? api_element("li", stc9, [api_custom_element("ace-help-center", _aceHelpCenter, {
    props: {
      "isLoggedIn": $cmp.isLoggedIn
    },
    key: 19
  })]) : null, !$cmp.isAgentExchange ? $cmp.isLoggedIn ? api_element("li", stc10, [api_custom_element("ace-favorites", _aceFavorites, stc11)]) : null : null])]) : null]), !$cmp.showBasicHeader ? api_element("div", stc12, [!$cmp.isPhoneNavExpanded ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc13,
    attrs: stc14,
    props: {
      "variant": "secondary",
      "size": "small",
      "ariaExpanded": $cmp.isPhoneNavExpanded,
      "label": $cmp.labels.menu,
      "icon": "rows"
    },
    key: 23,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.toggleMenu))
    }
  }) : null, $cmp.isPhoneNavExpanded ? api_custom_element("wds-button", _wdsButton, {
    classMap: stc15,
    attrs: stc14,
    props: {
      "variant": "tertiary",
      "size": "small",
      "ariaExpanded": $cmp.isPhoneNavExpanded,
      "label": $cmp.sharedLabels.close,
      "icon": "close"
    },
    key: 24,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.toggleMenu))
    }
  }) : null, api_static_fragment($fragment4, 26), api_element("div", stc16, [api_element("ul", stc17, [!$cmp.isLoggedIn ? $cmp.isAppExchange ? api_element("li", stc18, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc13,
    attrs: stc19,
    props: {
      "size": "small",
      "name": "headerSignup",
      "label": $cmp.labels.signup
    },
    key: 30,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.signup))
    }
  })]) : null : null, !$cmp.isLoggedIn ? $cmp.isAppExchange ? api_element("li", stc20, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc13,
    attrs: stc21,
    props: {
      "variant": "secondary",
      "size": "small",
      "name": "headerLogin",
      "label": $cmp.labels.login
    },
    key: 32,
    on: {
      "click": _m3 || ($ctx._m3 = api_bind($cmp.login))
    }
  })]) : null : null, $cmp.isLoggedIn ? !$cmp.isAgentExchange ? api_element("li", stc22, [api_custom_element("ace-user-menu", _aceUserMenu, stc23)]) : null : null])])]) : null, !$cmp.showBasicHeader ? api_element("nav", {
    classMap: stc24,
    attrs: {
      "role": "navigation",
      "aria-label": $cmp.labels.navigationBar,
      "tabindex": "-1"
    },
    key: 35
  }, [api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, {
    props: stc25,
    key: 36,
    on: {
      "analytics": _m4 || ($ctx._m4 = api_bind($cmp.handleAnalytics))
    }
  }, [api_element("ul", stc26, [api_element("li", stc27, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "label": $cmp.labels.home
    },
    key: 39
  }, [api_static_fragment($fragment5, 41, [api_static_part(0, {
    attrs: {
      "href": $cmp.links.home
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.labels.home))])])]), api_element("li", stc28, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "label": $cmp.labels.explore.menuItem
    },
    key: 43
  }, [api_static_fragment($fragment6, 45, [api_static_part(0, {
    on: {
      "click": _m7 || ($ctx._m7 = api_bind($cmp.handleClick)),
      "keydown": _m8 || ($ctx._m8 = api_bind($cmp.handleKeyDown))
    },
    attrs: {
      "aria-expanded": $cmp.displayTooltip
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.labels.explore.menuItem))])]), !$cmp.isMobile ? !$cmp.isMobile ? api_custom_element("wds-popover", _wdsPopover, {
    props: {
      "show": $cmp.displayTooltip,
      "popoverOrientation": $cmp.popoverOrientation,
      "hideCloseButton": true
    },
    key: 46,
    on: {
      "keydown": _m9 || ($ctx._m9 = api_bind($cmp.handleTooltipKeyboardEvent)),
      "close": _m10 || ($ctx._m10 = api_bind($cmp.closePopover))
    }
  }, [api_element("div", stc29, api_iterator($cmp.bucketOptions, function (bucket) {
    return api_custom_element("ax-card", _axCard, {
      props: stc30,
      key: api_key(48, bucket.icon)
    }, [api_static_fragment($fragment7, 50, [api_static_part(1, {
      attrs: {
        "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", api_scoped_frag_id(bucket.icon))
      }
    }, null), api_static_part(3, null, api_dynamic_text(bucket.title))]), api_element("div", stc31, [api_custom_element("wds-link", _wdsLink, {
      props: {
        "label": bucket.title
      },
      key: 52
    }, [api_static_fragment($fragment8, 54, [api_static_part(0, {
      attrs: {
        "href": bucket.action
      }
    }, null), api_static_part(1, null, api_dynamic_text(bucket.title))])])]), api_static_fragment($fragment9, 56, [api_static_part(1, null, api_dynamic_text(bucket.description))])]);
  }))]) : null : null, $cmp.isMobile ? api_element("ul", stc32, api_iterator($cmp.bucketOptions, function (bucket) {
    return api_element("li", {
      classMap: stc33,
      key: api_key(58, bucket.icon)
    }, [api_element("div", stc34, [api_static_fragment($fragment10, 61, [api_static_part(1, {
      attrs: {
        "xlink:href": sanitizeAttribute("use", "http://www.w3.org/2000/svg", "xlink:href", api_scoped_frag_id(bucket.icon))
      }
    }, null), api_static_part(3, null, api_dynamic_text(bucket.title))]), api_element("div", stc35, [api_custom_element("wds-link", _wdsLink, stc36, [api_static_fragment($fragment11, 65, [api_static_part(0, {
      attrs: {
        "href": bucket.action
      }
    }, null), api_static_part(1, null, api_dynamic_text(bucket.title))])])])])]);
  })) : null]), !$cmp.isUserLanguageJapanese ? api_element("li", stc37, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "label": $cmp.labels.collections
    },
    key: 67
  }, [api_static_fragment($fragment12, 69, [api_static_part(0, {
    attrs: {
      "href": $cmp.links.collections
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.labels.collections))])])]) : null, api_element("li", stc38, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "label": $cmp.labels.consultants
    },
    key: 71
  }, [api_static_fragment($fragment13, 73, [api_static_part(0, {
    attrs: {
      "href": $cmp.links.consulting
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.labels.consultants))])])]), api_element("li", stc39, [api_custom_element("wds-link", _wdsLink, {
    props: {
      "label": $cmp.labels.learn
    },
    key: 75
  }, [api_static_fragment($fragment14, 77, [api_static_part(0, {
    attrs: {
      "href": $cmp.links.learn
    }
  }, null), api_static_part(2, null, api_dynamic_text($cmp.labels.learn))])])])])])]) : null, api_static_fragment($fragment15, 79), api_element("nav", stc40, [api_element("ul", stc41, [$cmp.isAppExchange ? !$cmp.showBasicHeader ? api_element("li", stc42, [api_custom_element("ace-help-center", _aceHelpCenter, {
    props: {
      "isLoggedIn": $cmp.isLoggedIn
    },
    key: 83
  })]) : null : null, $cmp.isLoggedIn ? !$cmp.isAgentExchange ? !$cmp.showBasicHeader ? api_element("li", stc43, [api_custom_element("ace-app-launcher", _aceAppLauncher, stc44)]) : null : null : null, $cmp.isLoggedIn ? !$cmp.isAgentExchange ? !$cmp.showBasicHeader ? api_element("li", stc45, [api_custom_element("ace-favorites", _aceFavorites, stc46)]) : null : null : null, $cmp.isLoggedIn ? !$cmp.isAgentExchange ? api_element("li", stc47, [api_custom_element("ace-user-menu", _aceUserMenu, stc48)]) : null : null, !$cmp.isLoggedIn ? $cmp.isAppExchange ? !$cmp.isLoggedIn ? api_element("li", stc49, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc13,
    attrs: stc19,
    props: {
      "size": "small",
      "name": "headerSignup",
      "label": $cmp.labels.signup
    },
    key: 91,
    on: {
      "click": _m11 || ($ctx._m11 = api_bind($cmp.signup))
    }
  })]) : null : null : null, !$cmp.isLoggedIn ? $cmp.isAppExchange ? !$cmp.isLoggedIn ? api_element("li", stc50, [api_custom_element("wds-button", _wdsButton, {
    classMap: stc13,
    attrs: stc21,
    props: {
      "variant": "secondary",
      "size": "small",
      "name": "headerLogin",
      "label": $cmp.labels.login
    },
    key: 93,
    on: {
      "click": _m12 || ($ctx._m12 = api_bind($cmp.login))
    }
  })]) : null : null : null])])]), !$cmp.showBasicHeader ? api_element("div", stc51, [api_custom_element("search-type-ahead", _searchTypeAhead, stc52)]) : null])])];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-380pk3clve5";
tmpl.legacyStylesheetToken = "undefined-_header";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
